import { Record } from 'immutable';

const StaySummaryRecord = Record({
  totalNights: 0,
  totalRevenue: 0,
  avgRoomRate: 0,
  totalItems: 0,
  totalCommission: 0
});

export class StaySummary extends StaySummaryRecord {
  totalNights: number;
  totalRevenue: number;
  avgRoomRate: number;
  totalItems: number;
  totalCommission: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/stay-summary.ts